"use client";
import type { FC, HTMLProps } from "react";

import STYLES from "@vita-learning/styles";

import Button, { type ButtonProps } from "./Button";

const { normal, interaction } = STYLES.colors.lights.backgrounds.dangers;

export const DeleteButton: FC<
	Omit<HTMLProps<HTMLButtonElement>, keyof ButtonProps> & ButtonProps
> = ({ children, ...props }) => (
	<Button {...props} color={normal} pseudoColor={interaction}>
		{children}
	</Button>
);
